import { ComponentRoute } from '@/classes'

const UsedPartsInfoRoutes = {
  UsedPartsInfoListView: new ComponentRoute('/usedpartsinfo', 'UsedPartsInfoListView')
}

export default UsedPartsInfoRoutes
